var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"position":"fixed","right":"0","height":"85px","width":"85px","margin":"10px 20px","transform":"translateZ(0)","z-index":"9998","bottom":"0"},attrs:{"name":"iframe-webchat","id":"iframe-webchat","frameborder":"0"}})}
var staticRenderFns = []

export { render, staticRenderFns }